import script from "./CustomAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomAlert.vue?vue&type=script&setup=true&lang=js"

import "./CustomAlert.vue?vue&type=style&index=0&id=510d6651&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-510d6651"]])

export default __exports__